import { render, staticRenderFns } from "./OnboardAudit.vue?vue&type=template&id=3b024578&"
import script from "./OnboardAudit.vue?vue&type=script&lang=js&"
export * from "./OnboardAudit.vue?vue&type=script&lang=js&"
import style0 from "./OnboardAudit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports